/* My Kid's Dream - live book preview, part 1: registry + name patcher.
 * Add a book: upload its sample PDF to Shopify Files, add one BOOKS entry.
 * Patcher swaps the sample name inside the real PDF (story text encoding:
 * codepoint-31 as 4-hex pairs; cover title: per-font code table). */
window.MKDP = window.MKDP || {};
MKDP.BOOKS = {
  'personalized-jesus-at-christmas-book-for-children': {
    pdfUrl: 'https://cdn.shopify.com/s/files/1/0611/4823/3984/files/jesus-at-christmas-preview.pdf?v=1792796891',
    sampleName: 'Elizabeth',
    pages: 33,
    personalize: true,
    formats: [
      { id: 50734907785472, label: 'Softcover', price: '$29.95' },
      { id: 50734907818240, label: 'Hardcover', price: '$39.95', tag: 'Most gifted' }
    ],
    defaultFormat: 1,
    titleCodes: {" ":1,"&":2,"'":3,"A":4,"B":5,"C":6,"D":7,"E":8,"F":9,"G":10,"H":11,"I":12,"J":13,"K":14,"L":15,"M":16,"N":17,"O":18,"P":19,"Q":20,"R":21,"S":22,"T":23,"U":24,"V":25,"W":26,"X":27,"Y":28,"Z":29,"a":31,"b":32,"c":33,"d":34,"e":35,"f":36,"g":37,"h":38,"i":39,"j":40,"k":41,"l":42,"m":43,"n":44,"o":45,"p":46,"q":47,"r":48,"s":49,"t":50,"u":51,"v":52,"w":53,"x":54,"y":55,"z":56,"À":59,"Á":60,"Â":61,"Ä":62,"Å":63,"Æ":64,"È":65,"É":66,"Ê":67,"Ë":68,"Ì":69,"Í":70,"Î":71,"Ï":72,"Ò":73,"Ó":74,"Ô":75,"Ö":76,"Ù":77,"Ú":78,"Û":79,"Ü":80,"à":81,"á":82,"â":83,"ä":84,"å":85,"æ":86,"è":87,"é":88,"ê":89,"ë":90,"ì":91,"í":92,"î":93,"ï":94,"ò":95,"ó":96,"ô":97,"ö":98,"ù":99,"ú":100,"û":101,"ü":102,"ý":103,"ÿ":104,"Œ":105,"œ":106,"š":107,"Ÿ":108,"ˆ":109}
  },
  'bedtime-prayers-personalized-childrens-book': {
    pdfUrl: 'https://cdn.shopify.com/s/files/1/0611/4823/3984/files/bedtime-prayers-preview.pdf?v=1792809161',
    sampleName: 'Elizabeth',
    pages: 33,
    personalize: true,
    formats: [
      { id: 50734957494528, label: 'Softcover', price: '$29.95' },
      { id: 50734957527296, label: 'Hardcover', price: '$39.95', tag: 'Most gifted' }
    ],
    defaultFormat: 1,
    titleCodes: {" ":3,"&":9,"'":10,"A":36,"B":37,"C":38,"D":39,"E":40,"F":41,"G":42,"H":43,"I":44,"J":45,"K":46,"L":47,"M":48,"N":49,"O":50,"P":51,"Q":52,"R":53,"S":54,"T":55,"U":56,"V":57,"W":58,"X":59,"Y":60,"Z":61,"a":68,"b":69,"c":70,"d":71,"e":72,"f":73,"g":74,"h":75,"i":76,"j":77,"k":78,"l":79,"m":80,"n":81,"o":82,"p":83,"q":84,"r":85,"s":86,"t":87,"u":88,"v":89,"w":90,"x":91,"y":92,"z":93,"À":163,"Á":164,"Â":165,"Ä":167,"Å":168,"Æ":169,"È":171,"É":172,"Ê":173,"Ë":174,"Ì":175,"Í":176,"Î":177,"Ï":178,"Ò":181,"Ó":182,"Ô":183,"Ö":185,"Ù":188,"Ú":189,"Û":190,"Ü":191,"à":195,"á":196,"â":197,"ä":199,"å":200,"æ":201,"è":203,"é":204,"ê":205,"ë":206,"ì":207,"í":208,"î":209,"ï":210,"ò":213,"ó":214,"ô":215,"ö":217,"ù":220,"ú":221,"û":222,"ü":223,"ý":224,"ÿ":226,"Œ":309,"œ":310,"š":324,"Ÿ":347,"ˆ":681}
  }
};
MKDP.encodeStory = function (name) {
  var out = '';
  for (var i = 0; i < name.length; i++) {
    var v = name.charCodeAt(i) - 31;
    if (v < 0 || v > 255) return null;
    out += ('000' + v.toString(16).toUpperCase()).slice(-4);
  }
  return out;
};
MKDP.encodeTitle = function (name, table) {
  var out = '';
  for (var i = 0; i < name.length; i++) {
    var code = table[name[i]];
    if (code == null) return null;
    out += ('000' + code.toString(16).toUpperCase()).slice(-4);
  }
  return out;
};
MKDP.sanitizeName = function (raw) {
  var n = (raw || '').replace(/['\u2019]/g, '').trim();
  if (!n) return '';
  n = n.slice(0, 12);
  return n.charAt(0).toUpperCase() + n.slice(1);
};
MKDP.u8ToLatin1 = function (u8) {
  var s = '', CH = 65536;
  for (var i = 0; i < u8.length; i += CH) s += String.fromCharCode.apply(null, u8.subarray(i, i + CH));
  return s;
};
MKDP.latin1ToU8 = function (s) {
  var u8 = new Uint8Array(s.length);
  for (var i = 0; i < s.length; i++) u8[i] = s.charCodeAt(i) & 0xff;
  return u8;
};
MKDP.findStreams = function (text) {
  var streams = [], idx = 0;
  while (true) {
    var s = text.indexOf('stream', idx);
    if (s === -1) break;
    if (text.slice(Math.max(0, s - 3), s) === 'end') { idx = s + 6; continue; }
    var start = s + 6;
    if (text[start] === '\r' && text[start + 1] === '\n') start += 2;
    else if (text[start] === '\n' || text[start] === '\r') start += 1;
    var e = text.indexOf('endstream', start);
    if (e === -1) break;
    var end = e;
    if (text[end - 1] === '\n') end -= 1;
    if (text[end - 1] === '\r') end -= 1;
    var dictStart = text.lastIndexOf('<<', s);
    streams.push({ dictStart: dictStart, dict: dictStart === -1 ? '' : text.slice(dictStart, s), dataStart: start, dataEnd: end });
    idx = e + 9;
  }
  return streams;
};
function mkdpPipe(u8, transform) {
  var stream = new Blob([u8]).stream().pipeThrough(transform);
  return new Response(stream).arrayBuffer().then(function (ab) { return new Uint8Array(ab); });
}
MKDP.patchPdf = function (origBytes, sampleName, newName, table) {
  var storyOld = MKDP.encodeStory(sampleName), storyNew = MKDP.encodeStory(newName);
  var titleOld = MKDP.encodeTitle(sampleName, table), titleNew = MKDP.encodeTitle(newName, table);
  var text = MKDP.u8ToLatin1(origBytes);
  var streams = MKDP.findStreams(text);
  var jobs = [];
  streams.forEach(function (st, i) {
    if (!/FlateDecode/.test(st.dict)) return;
    jobs.push(mkdpPipe(origBytes.subarray(st.dataStart, st.dataEnd), new DecompressionStream('deflate')).then(function (inflated) {
      var txt = MKDP.u8ToLatin1(inflated), before = txt;
      if (storyOld && storyNew) txt = txt.split(storyOld).join(storyNew);
      if (titleOld && titleNew) txt = txt.split(titleOld).join(titleNew);
      if (txt === before) return null;
      return mkdpPipe(MKDP.latin1ToU8(txt), new CompressionStream('deflate')).then(function (deflated) {
        return { index: i, deflated: deflated };
      });
    }).catch(function () { return null; }));
  });
  return Promise.all(jobs).then(function (results) {
    var byIndex = {};
    results.forEach(function (r) { if (r) byIndex[r.index] = r.deflated; });
    var out = origBytes;
    for (var i = streams.length - 1; i >= 0; i--) {
      var deflated = byIndex[i];
      if (!deflated) continue;
      var st = streams[i];
      var dictSeg = MKDP.u8ToLatin1(out.subarray(st.dictStart, st.dataStart));
      var newDictSeg = dictSeg.replace(/\/Length(?![\dA-Za-z])\s*\d+/, '/Length ' + deflated.length);
      var head = out.subarray(0, st.dictStart);
      var mid = MKDP.latin1ToU8(newDictSeg);
      var tail = out.subarray(st.dataEnd);
      var merged = new Uint8Array(head.length + mid.length + deflated.length + tail.length);
      merged.set(head, 0); merged.set(mid, head.length);
      merged.set(deflated, head.length + mid.length);
      merged.set(tail, head.length + mid.length + deflated.length);
      out = merged;
    }
    return { bytes: out, titlePatched: !!(titleOld && titleNew) };
  });
};
